import React, { useEffect } from 'react';
import classNames from 'classnames';
import EditorJS from '@editorjs/editorjs';
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import { tools } from './tools.js';
import { defaultOptions } from './defaultOptions.js';

const Editor = ({
  label,
  children,
  data,
  options,
  setEditorInstanceForParent,
  isNeedToSetLimitOfLinesNumber,
  meta,
  customClass,
}) => {
  const hasError = meta
    ? meta.touched && (meta.error || meta.submitError)
    : false;

  useEffect(() => {
    let editor;

    // Wait for next frame to ensure React has rendered the DOM
    const frameId = requestAnimationFrame(() => {
      const holderElement = document.getElementById(options.holder);
      if (!holderElement) {
        console.warn(`Editor holder element #${options.holder} not found`);
        return;
      }

      editor = new EditorJS({
        tools,
        data: data || {},
        defaultBlock: 'paragraph',
        ...defaultOptions,
        ...options,
      });
      setEditorInstanceForParent && setEditorInstanceForParent(editor);
    });

    // cleanup
    return () => {
      cancelAnimationFrame(frameId);

      if (editor) {
        editor.isReady
          .then(() => {
            const holderStillExists = document.getElementById(options.holder);
            if (holderStillExists) {
              editor.destroy();
            }
          })
          .catch((e) => {
            if (!e.message?.includes('is missing')) {
              console.error('ERROR editor cleanup', e);
            }
          });
      }
    };
  }, [options.holder, options.readOnly]);

  return (
    <FormGroup
      controlId={options.holder}
      validationState={hasError ? 'error' : null}
      className={customClass}
    >
      <div className="editor-container">
        {label && <ControlLabel>{label}</ControlLabel>}
        {!children && (
          <div
            id={options.holder}
            className={classNames('editor-wrapper', {
              'read-only': options.readOnly,
              'lines-of-number-limit': isNeedToSetLimitOfLinesNumber,
            })}
          ></div>
        )}
        {children}
      </div>
      {hasError && <HelpBlock>{meta.error || meta.submitError}</HelpBlock>}
    </FormGroup>
  );
};

export default Editor;
